import { useTheme } from '@emotion/react';
// Default Icons
import CalendarIcon from 'imagesUwKluis/svg/default/calendar.svg';
import CalculationIcon from 'imagesUwKluis/svg/default/calculation.svg';
import DashboardIcon from 'imagesUwKluis/svg/default/dashboard.svg';
import DocumentsIcon from 'imagesUwKluis/svg/default/documents.svg';
import RequestIcon from 'imagesUwKluis/svg/default/request.svg';
import QuestionnaireIcon from 'imagesUwKluis/svg/default/questionnaire.svg';
import HouseIcon from 'imagesUwKluis/svg/default/house.svg';
import LogoutIcon from 'imagesUwKluis/svg/default/logout.svg';
import MessageIcon from 'imagesUwKluis/svg/default/message.svg';
import ProductIcon from 'imagesUwKluis/svg/default/product.svg';
import ProfileIcon from 'imagesUwKluis/svg/default/profile.svg';
import SettingsIcon from 'imagesUwKluis/svg/default/settings.svg';
import ContactIcon from 'imagesUwKluis/svg/default/contact.svg';
import LinkIcon from 'imagesUwKluis/svg/default/link.svg';
import MortgageIcon from 'imagesUwKluis/svg/default/mortgage.svg';
import ShieldIcon from 'imagesUwKluis/svg/default/shield.svg';
import CurrencyIcon from 'imagesUwKluis/svg/default/currency_euro.svg';
import EditIcon from 'imagesUwKluis/svg/default/edit.svg';
import OcktoIcon from 'imagesUwKluis/svg/default/ockto_icon.svg';
import VeiligOphalenIcon from 'imagesUwKluis/svg/default/vo_icon.svg';
import LanguageIcon from 'imagesUwKluis/svg/default/language.svg';
import DamageIcon from 'imagesUwKluis/svg/default/damage.svg';
// Argo Icons
import ArgoCalendarIcon from 'imagesUwKluis/svg/argo/calendar.svg';
import ArgoCalculationIcon from 'imagesUwKluis/svg/argo/calculation.svg';
import ArgoDashboardIcon from 'imagesUwKluis/svg/argo/dashboard.svg';
import ArgoDocumentsIcon from 'imagesUwKluis/svg/argo/documents.svg';
import ArgoRequestIcon from 'imagesUwKluis/svg/argo/request.svg';
import ArgoQuestionnaireIcon from 'imagesUwKluis/svg/argo/questionnaire.svg';
import ArgoHouseIcon from 'imagesUwKluis/svg/argo/house.svg';
import ArgoLogoutIcon from 'imagesUwKluis/svg/argo/logout.svg';
import ArgoMessageIcon from 'imagesUwKluis/svg/argo/message.svg';
import ArgoProductIcon from 'imagesUwKluis/svg/argo/product.svg';
import ArgoProfileIcon from 'imagesUwKluis/svg/argo/profile.svg';
import ArgoSettingsIcon from 'imagesUwKluis/svg/argo/settings.svg';
import ArgoContactIcon from 'imagesUwKluis/svg/argo/contact.svg';
import ArgoLinkIcon from 'imagesUwKluis/svg/argo/link.svg';
import ArgoMortgageIcon from 'imagesUwKluis/svg/argo/mortgage.svg';
import ArgoShieldIcon from 'imagesUwKluis/svg/argo/shield.svg';
import ArgoCurrencyIcon from 'imagesUwKluis/svg/argo/currency_euro.svg';
import ArgoEditIcon from 'imagesUwKluis/svg/argo/edit.svg';
import ArgoOcktoIcon from 'imagesUwKluis/svg/argo/ockto_icon.svg';
import ArgoVeiligOphalenIcon from 'imagesUwKluis/svg/argo/vo_icon.svg';
import ArgoAddPersonIcon from 'imagesUwKluis/svg/argo/add_person.svg';
import ArgoForwardsIcon from 'imagesUwKluis/svg/argo/forward.svg';
import ArgoLanguageIcon from 'imagesUwKluis/svg/argo/language.svg';

const defaultIcons = {
  CalendarIcon: CalendarIcon,
  CalculationIcon: CalculationIcon,
  DashboardIcon: DashboardIcon,
  DocumentsIcon: DocumentsIcon,
  QuestionnaireIcon: QuestionnaireIcon,
  RequestIcon: RequestIcon,
  HouseIcon: HouseIcon,
  LogoutIcon: LogoutIcon,
  MessageIcon: MessageIcon,
  LinkIcon: LinkIcon,
  ProductIcon: ProductIcon,
  ProfileIcon: ProfileIcon,
  SettingsIcon: SettingsIcon,
  ContactIcon: ContactIcon,
  MortgageIcon: MortgageIcon,
  ShieldIcon: ShieldIcon,
  CurrencyIcon: CurrencyIcon,
  EditIcon: EditIcon,
  OcktoIcon: OcktoIcon,
  VeiligOphalenIcon: VeiligOphalenIcon,
  AddPersonIcon: ArgoAddPersonIcon,
  ForwardIcon: ArgoForwardsIcon,
  LanguageIcon: LanguageIcon,
  DamageIcon: DamageIcon,
};

const argoIcons = {
  CalendarIcon: ArgoCalendarIcon,
  CalculationIcon: ArgoCalculationIcon,
  DashboardIcon: ArgoDashboardIcon,
  DocumentsIcon: ArgoDocumentsIcon,
  QuestionnaireIcon: ArgoQuestionnaireIcon,
  RequestIcon: ArgoRequestIcon,
  HouseIcon: ArgoHouseIcon,
  LogoutIcon: ArgoLogoutIcon,
  MessageIcon: ArgoMessageIcon,
  LinkIcon: ArgoLinkIcon,
  ProductIcon: ArgoProductIcon,
  ProfileIcon: ArgoProfileIcon,
  SettingsIcon: ArgoSettingsIcon,
  ContactIcon: ArgoContactIcon,
  MortgageIcon: ArgoMortgageIcon,
  ShieldIcon: ArgoShieldIcon,
  CurrencyIcon: ArgoCurrencyIcon,
  EditIcon: ArgoEditIcon,
  OcktoIcon: ArgoOcktoIcon,
  VeiligOphalenIcon: ArgoVeiligOphalenIcon,
  AddPersonIcon: ArgoAddPersonIcon,
  ForwardIcon: ArgoForwardsIcon,
  LanguageIcon: ArgoLanguageIcon,
};

export const useIconLibrary = (): typeof defaultIcons => {
  const { usesArgoIcons } = useTheme();
  const source = usesArgoIcons
    ? { ...defaultIcons, ...argoIcons }
    : defaultIcons;

  return source;
};

export default useIconLibrary;
